import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import Box from '@mui/material/Box';

import './styles.css';

// Display row of small cards (Restaurants / Things To Do) inside the itinerary
// timeline. Standardized: theme radius, tokenized text, dark-mode-safe, and a
// graceful empty line instead of rendering a stray "0" when the list is empty.
const SmallSelectableCards = ({ title, list }) => {
  const hasItems = list && list.length > 0;
  return (
    <Box>
      <Typography sx={{ marginTop: '1em', fontSize: '1em' }} component="div" className='txt--sub-heading'>
        {title}
      </Typography>
      <div className="small-selectable-cards">
        {hasItems ? (
          list.map((item, index) => (
            <Card
              key={`${item.images?.[0] || 'img'}-${index}`}
              className='small-selectable-cards-card'
              sx={{ width: 'auto', maxWidth: '160px', borderRadius: 2, marginBottom: '12px' }}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="160px"
                  sx={{ width: '100%', maxHeight: '10em', height: '45vw' }}
                  image={item.images?.[0] || ''}
                  alt={item.name}
                />
                <CardContent>
                  <Typography
                    component="div"
                    sx={{ fontSize: '.8em', lineHeight: '1.1em', display: 'flex', alignItems: 'center', height: '2em', color: 'text.primary' }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))
        ) : (
          <Typography color="text.secondary" sx={{ py: 1, fontSize: '.85em' }}>
            None listed.
          </Typography>
        )}
      </div>
    </Box>
  );
};

export default SmallSelectableCards;
